import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCartAPI = (userId, token) => {
  return axios.get(`${BASE_URL}/cart/user/${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const addToCartAPI = (payload, token) => {
  return axios.post(`${BASE_URL}/cart`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateCartItemAPI = (cartItemId, payload, token) => {
  return axios.put(`${BASE_URL}/cart/${cartItemId}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const removeCartItemAPI = (cartItemId, token) => {
  return axios.delete(`${BASE_URL}/cart/${cartItemId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const clearUserCart = async (userId, token) => {
  try {
    const res = await axios.delete(`${BASE_URL}/cart/clear/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    console.error("Failed to clear user cart:", err);
    throw err;
  }
};


